import React from 'react';
import type { LegacyBridgeContentFragment_content$key } from '@confluence/content-unified-query/entry-points/LegacyBridgeContentFragmentTypes.ts';
import { LegacyBridgeContentFragment } from '@confluence/content-unified-query/entry-points/LegacyBridgeContentFragment.ts';
import { useFragment } from 'react-relay';
import { expVal } from '@confluence/feature-experiments';
import { isReusableLegacyBridgeContent } from '@confluence/query-preloaders-common/entry-points/isReusableLegacyBridgeContent.ts';
import { usePageContentId } from '@confluence/page-context';

import { LegacyBridgeNextInner } from './LegacyBridgeNextInner.tsx';

export function LegacyBridgeNext({
	contentFragmentRef,
}: {
	contentFragmentRef?: LegacyBridgeContentFragment_content$key | null;
}): React.JSX.Element | null {
	const [contentId] = usePageContentId();

	if (!contentId) {
		return null;
	}

	if (
		contentFragmentRef &&
		expVal('confluence_exp_legacy_bridge_content_reuse', 'isEnabled', false)
	) {
		return (
			<LegacyBridgeContentReader contentId={contentId} contentFragmentRef={contentFragmentRef} />
		);
	}

	return <LegacyBridgeNextInner contentId={contentId} />;
}

function LegacyBridgeContentReader({
	contentId,
	contentFragmentRef,
}: {
	contentId: string;
	contentFragmentRef?: LegacyBridgeContentFragment_content$key | null;
}): React.JSX.Element {
	const content = useFragment(LegacyBridgeContentFragment, contentFragmentRef ?? null);
	const reuseContent = isReusableLegacyBridgeContent(content, contentId);
	return <LegacyBridgeNextInner contentId={contentId} content={reuseContent ? content : null} />;
}
